export var themeDepLibrary = {
  vue: '@arco-design/web-vue',
  react: '@arco-design/web-react'
};
export var ALLOW_THEME_CREATE = false;
export var themeOperate = {
  create: 'create',
  edit: 'edit',
  copy: 'copy'
};